import React from 'react'

import styles from 'components/pages/support/help/helpStyles'
import { HelpComponentProps } from 'types/Help'
import { useFormatMessage } from 'lib/localization'
import { isMyFeatureOn } from 'lib/splitio'
import { FEATURES } from 'lib/splitioFeatures'

function ComplianceI18n({ classes, productName }: { classes: ReturnType<typeof styles>; productName?: string }) {
  const formatMessage = useFormatMessage('ess.help_compliance')
  return (
    <div className={classes.content} data-testid="content">
      {formatMessage('intro')}
      <h3 id="help-licenses">{formatMessage('licenses.title')}</h3>
      {formatMessage('licenses.description', { productName })}
      <br />
    </div>
  )
}

function Compliance(props: HelpComponentProps) {
  const classes = styles()
  let isSmartlingEnabled = false
  try {
    isSmartlingEnabled = isMyFeatureOn(FEATURES.EGD_React_Smartling_Translations)
  } catch {
    // Default to OFF when called outside Redux context (e.g., renderToString for search)
  }

  // Flag ON: Use translated content
  if (isSmartlingEnabled) {
    return <ComplianceI18n classes={classes} productName={props.productName} />
  }

  // Flag OFF: Original hardcoded English content
  return (
    <div className={classes.content} data-testid="content">
      When the total number of <b>Active</b> users on your account in a 30-day period exceeds the number of user
      licenses (<b>Recipients</b>) on your account, you are out of compliance.
      <h3 id="help-licenses">User Licenses</h3>
      Billing is based on the number of user mailboxes receiving and/or sending mail the mail server recognizes in{' '}
      {props.productName} in a 30-day period.
      <br />
    </div>
  )
}

export default Compliance
